"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __importDefault(require("querystring"));
var Sentry = __importStar(require("@sentry/react"));
var types_1 = require("./types");
var actions_1 = __importDefault(require("../../app/components/pages/RootPage/actions"));
var requests_1 = require("../../app/util/requests");
var types_2 = require("../../app/util/types");
var ga_1 = require("../../app/util/ga");
function setDirectoryResults(payload) {
    return {
        type: types_1.SET_DIRECTORY_RESULTS,
        payload: payload,
    };
}
function resetDirectoryResults() {
    return {
        type: types_1.SET_INITIAL_STATE,
    };
}
var getDirectoryResults = function (query, order, rowsPerPage, currentPage, state, isFile, isEmail) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var offset, limit, paramsObj, params, response, json, filteredQuery;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!query.trim()) {
                        return [2 /*return*/];
                    }
                    offset = currentPage * rowsPerPage;
                    limit = rowsPerPage;
                    paramsObj = __assign(__assign({ query: query, order: order, limit: limit, offset: offset }, (state && { state: state })), { isFile: isFile, isEmail: isEmail });
                    params = querystring_1.default.stringify(paramsObj);
                    return [4 /*yield*/, requests_1.get("/api/directory/search?" + params)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    if (!response.ok) {
                        // Report error from endpoints
                        ga_1.GAEvent('directory page', query, 'unsuccessful');
                        Sentry.captureMessage('directory search unsuccessful');
                        dispatch(actions_1.default.setErrorMessage(json.message || 'Error fetching search results'));
                        return [2 /*return*/];
                    }
                    filteredQuery = '';
                    if (isEmail === 'true') {
                        // split by space, then split each subset by @ and take the last part (domain), then rejoin back the string
                        filteredQuery = query
                            .split(' ')
                            .map(function (subset) { return subset.split('@').slice(-1); })
                            .join(' ');
                    }
                    else {
                        // Remove all words that have @ inside to prevent potential email address problem
                        filteredQuery = query.replace('@', ' ');
                    }
                    ga_1.GAEvent('directory page', filteredQuery, 'successful', parseInt("" + json.count, 10));
                    dispatch(setDirectoryResults({
                        count: json.count,
                        urls: json.urls,
                        query: query,
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
};
var redirectToDirectoryPage = function (history, query) {
    return function () {
        history.push({
            pathname: types_2.DIRECTORY_PAGE,
            search: querystring_1.default.stringify({ query: query }),
        });
    };
};
exports.default = {
    getDirectoryResults: getDirectoryResults,
    setDirectoryResults: setDirectoryResults,
    redirectToDirectoryPage: redirectToDirectoryPage,
    resetDirectoryResults: resetDirectoryResults,
};
